import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
  container: (props: any) => ({
    position: props.matches ? "absolute" : "relative",
    left: props.matches ? 0 : "unset",
    top: props.matches ? "3rem" : 0,
    display: props.open ? "flex" : "none",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    rowGap: props.matches ? "3rem" : "1rem",
    width: "100%",
    maxWidth: "100vw",
    height: props.matches ? "80vh" : "100%",
    padding: props.matches ? "3rem 8rem" : "1rem",
    paddingRight: props.matches ? "8rem" : "4rem",
    backgroundColor: theme.whiteColor,
    boxShadow: props.matches ? "0px 60vh rgb(112,112,112,0.6)" : "none",
    fontSize: "0.9rem",
    overflowY: "scroll",
    zIndex: 99,

    "&::-webkit-scrollbar": {
      display: "none",
    },
  }),
  searchBar: (props: any) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    minWidth: props.matches ? "30rem" : "unset",
    width: props.matches ? "35%" : "calc(100% - 3rem)",
    height: "2rem",
    borderBottom: "1px solid",
    "& > input": {
      width: "100%",
      border: "none",
      outline: "none",
      fontSize: "1rem",
      fontFamily: theme.fontFamilyArchivo,
      color: theme.darkSlateGrayColor,
    },
    "& > input::placeholder": {
      color: theme.darkSlateGrayColor,
    },
    "& > button": {
      border: "none",
      outline: "none",
      background: "none",
      cursor: "pointer",
    },
  }),
  oneToZ: (props: any) => ({
    position: props.matches ? "relative" : "absolute",
    top: 0,
    right: 0,
    display: "flex",
    flexDirection: props.matches ? "row" : "column",
    rowGap: props.matches ? "unset" : "1rem",
    justifyContent: "space-between",
    width: props.matches ? "100%" : "3.5rem",
    height: props.matches ? "unset" : "100%",
    paddingTop: props.matches ? "0" : "4rem",
    paddingBottom: props.matches ? "0" : "1rem",
    backgroundColor: props.matches ? "unset" : theme.darkerWhiteSmokeColor,
    overflowY: props.matches ? "unset" : "auto",
    fontSize: props.matches ? "unset" : "0.9rem",
  }),
  groupBtn: (props: any) => ({
    fontFamily: theme.fontFamilyLexendDeca,
    fontSize: "1.1rem",
    fontWeight: 600,
    cursor: "pointer",
    border: "none",
    outline: "none",
    background: "none",
    color:
      props.selectedForBtn === undefined
        ? theme.darkSlateGrayColor
        : props.selectedForBtn === true
        ? theme.darkSlateGrayColor
        : theme.silverColor,
  }),
  brandsContainer: (props: any) => ({
    display: "flex",
    flexDirection: "column",
    flexWrap: props.matches ? "wrap" : "nowrap",
    alignSelf: "flex-start",
    columnGap: "7rem",
    rowGap: "1.5rem",
    width: props.matches ? "25%" : "100%",
    height: props.matches
      ? `calc(${props.brandsHeight / 3}px + 10rem)`
      : "max-content",
    overflowY: props.matches ? "unset" : "scroll",
    paddingTop: props.matches ? "unset" : "1.5rem",
  }),
  hidden: {
    position: "fixed",
    visibility: "hidden",
    display: "flex",
    flexDirection: "column",
    rowGap: "2rem",
    top: 0,
    zIndex: -99,
  },
  brand: (props: any) => ({
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    color:
      props.selected === undefined
        ? theme.darkSlateGrayColor
        : props.selected === true
        ? theme.darkSlateGrayColor
        : theme.silverColor,
    paddingBottom: props.matches ? "unset" : "1.5rem",
    borderBottom: props.matches
      ? "none"
      : `2px solid ${theme.lighterGreyColor}`,
  }),
  brandGroup: (props: any) => ({
    width: props.matches ? "25%" : "3rem",
    fontFamily: theme.fontFamilyLexendDeca,
    fontSize: props.matches ? "1.1rem" : "1rem",
    fontWeight: 600,
  }),
  brandTitles: (props: any) => ({
    display: "flex",
    flexDirection: "column",
    width: props.matches ? "75%" : "100%",
    rowGap: "0.4rem",
    fontFamily: theme.fontFamilyQuestrial,
    fontSize: props.matches ? "unset" : "0.9rem",

    "& > a": {
      color: "inherit",
      textDecoration: "none",
    },
  }),
  generalBtn: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 0,
    border: "none",
    backgroundColor: "unset",
    zIndex: 99,
  },
  closeBtn: {
    position: "absolute",
    top: "1rem",
    right: "1rem",
  },
}));

export default useStyles;
